import {Typography, Tooltip, IconButton, Dialog, Button, Avatar } from "@mui/material";
import {Box, CustomButton, CustomDataGrid, CustomToggleButton, dayjs, EditCalendarIcon, GridRenderCellParams, useApi, useParams } from "../../../utils/globalImports";
import { useEffect, useState } from 'react';
import { ListAltOutlined } from "@mui/icons-material";
import CustomTPLModal from "../../../components/modal/CustomTPLModal";
import CustomSubStageModal from "../../../components/modal/CustomSubStageModal";
import CustomMilestoneModal from "../../../components/modal/CustomMilestoneModal";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EmojiFlagsOutlinedIcon from '@mui/icons-material/EmojiFlagsOutlined';
interface ProposalFeeStageSubStage {
  id?: number,
  subStageName: string,
  currentCost: number,
  revisedCost: number,
  startDate: string,
  endDate: string,
  feeSubStageArea: string,
  completedByIndia: string,
  feeStageTPL: string,
  status: string
}
interface ProposalFeeStageSubStage2 {
  id?: number,
  subStageName: string,
  currentCost: number,
  revisedCost: number,
  startDate: string,
  endDate: string,
  feeSubStageArea: string,
  completedByIndia: string,
  feeStageTPL: string,
  status: string
}
interface ProposalFeeStageSubStageProps {
}
const ProposalFeeStageSubStage: React.FC<ProposalFeeStageSubStageProps> = ({
}) => {
  const { execute } = useApi();
  const [rows, setRows] = useState<ProposalFeeStageSubStage[] | null>([]);
  // const rows = [
  //   {
  //     id: 1,
  //     subStageName: "Concept Design",
  //     currentCost: 25000,
  //     revisedCost: 27000,
  //     startDate: "2025-01-10",
  //     endDate: "2026-02-05",
  //     feeStageArea: "Test Area",
  //     completedByIndia: "Yes",
  //     status: "Active"

  //   },
  //   {
  //     id: 2,
  //     subStageName: "Detailed Design",
  //     currentCost: 40000,
  //     revisedCost: 42000,
  //     startDate: "2025-02-06",
  //     endDate: "2026-03-15",
  //     feeStageArea: "LX Census",
  //     completedByIndia: "No",
  //     status: "Active"

  //   },
  //   {
  //     id: 3,
  //     subStageName: "Detailed Documentation",
  //     currentCost: 60000,
  //     revisedCost: 58000,
  //     startDate: "2025-03-16",
  //     endDate: "2026-05-01",
  //     feeStageArea: "Prelims",
  //     completedByIndia: "Yes",
  //     status: "Active"

  //   },
  // ];
  //useState
  const { feeStageId } = useParams<{ feeStageId?: string }>()
  const [isTPLModalOpen, setTPLModalOpen] = useState(false)
  const [isAddSubStageModalOpen, setAddSubStageModalOpen] = useState(false)
  const [isMilestoneModalOpen, setMilestoneModalOpen] = useState(false)
  const [selectedSubStageId, setSelectedSubStageId] = useState<number | null>(null)
  const [selectedRow, setSelectedRow] = useState<any | null>(null)
  const [updateToggle, setUpdateToggle] = useState(false);
  const AlreadyExist = (Name: string) => {
    return rows?.some(row => row.subStageName.toLowerCase() === Name.toLowerCase() && row.id !== selectedRow?.id);
  }

  const handleOpenTPL = (row: any) => {
    setSelectedSubStageId(row.id);
    setTPLModalOpen(true);
  };
  const handleOpenMilestone = (row: any) => {
    setSelectedSubStageId(row.id);
    setMilestoneModalOpen(true);
  }
  const handleEdit = (row: any) => {
    setSelectedSubStageId(row.id);
    setAddSubStageModalOpen(true);
    setSelectedRow(row);
  }

  const FetchFeeStages = async () => {
    try {
      const { data } = await execute<ProposalFeeStageSubStage[]>(
        'get',
        '/Proposal/SubFeeStages',
        {
          FeeStage: feeStageId
        }
      )
      const formattedData = (data || []).map(item => ({
        ...item,
        startDate: item.startDate
          ? dayjs(item.startDate).format("DD/MM/YYYY")
          : "",
        endDate: item.endDate
          ? dayjs(item.endDate).format("DD/MM/YYYY")
          : "",
        completedByIndia: (Number(item.completedByIndia) == 1) ? "Yes" : "No"

      }));
      setRows(formattedData);
    }
    catch (Exception) {

    }
  }

  const columns = [
    { field: "subStageName", headerName: "Sub Stage Name", flex: 1 },
    { field: "currentCost", headerName: "Current Cost", flex: 1 },
    { field: "revisedCost", headerName: "Revised Cost", flex: 1 },
    { field: "startDate", headerName: "Start Date", flex: 1 },
    { field: "endDate", headerName: "End Date", flex: 1 },
    { field: "feeSubStageArea", headerName: "Fee Stage Area", flex: 1 },
    {
      field: "completedByIndia",
      headerName: "Completed By India",
      flex: 1,
      renderCell: (params: any) => (
        <Typography
          style={{
            backgroundColor: params.value === "Yes" ? "#e8f5e9" : "#ffebee",
            color: params.value === "Yes" ? "#388e3c" : "#e53935",
            padding: "2px 14px",
            borderRadius: "6px",
            fontWeight: 500,
            fontSize: "0.875rem",
            display: "inline-block",
          }}
        >
          {params.value}
        </Typography>
      )
    },
    {
      field: "actions",
      headerName: "Action",
      flex: 1,
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            width: "100%",
          }}
        >
          <IconButton
            color="primary"
            aria-label="edit"
            onClick={() => {
              handleEdit(params.row);
            }}
          >
            <EditCalendarIcon sx={{ color: "#a3c63d" }} />
          </IconButton>

          <CustomToggleButton
            isOn={params.row.status == "1"}
            onClick={() => { setUpdateToggle(true); setAddSubStageModalOpen(true); setSelectedRow(params.row) }}
          />
        </div>
      ),
    },
    {
      field: "tpl",
      headerName: "TPL",
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title="Add / View TPL">
          <CustomButton          
            size="small"
            onClick={() => handleOpenTPL(params.row)}
            startIcon={<DescriptionOutlinedIcon sx={{fontSize:"12px"}}/>}
            sx={{
              p:0,
              height:"32px"
            }}
          >
            Manage TPL
          </CustomButton>
        </Tooltip>
      ),
    },
    {
      field: "milestone",
      headerName: "Milestone",
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip title="Add / View Milestone">
          <CustomButton
            startIcon={<EmojiFlagsOutlinedIcon sx={{ fontSize: "12px" }} />}
            size="small"
            onClick={() => handleOpenMilestone(params.row)}
          >
            Milestones
          </CustomButton>
        </Tooltip>
      ),
    },

  ];

  useEffect(() => {
    FetchFeeStages();
  }, [])

  return (
    <Box >
      <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            p: 0,
            borderRadius: 2,
            backgroundColor: "#fff",
            width: "fit-content",
          }}
        >
          {/* Icon Circle */}
          <Avatar
            sx={{
              width: 48,
              height: 48,
              backgroundColor: "#eef2ff",
              color: "#3f51b5",
            }}
          >
            <ListAltOutlined />
          </Avatar>

          {/* Text Content */}
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "#1e66ab",
                lineHeight: 1.2,
              }}
            >
              Sub Stage List
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "#6b7280",
                mt: 0.5,
              }}
            >
              View and manage all sub stages.
            </Typography>
          </Box>
        </Box>
        <CustomButton
          capsule
          type="button"
          sx={{
            textTransform: "none",
            whiteSpace: "nowrap",
            width: "auto",
            height: "40px",
          }}
          onClick={() => { setSelectedRow(null); setAddSubStageModalOpen(true) }}
        >
          <Typography sx={{ fontSize: "25px", color: "#fff", fontWeight: 400, marginRight: "8px" }}>
            +
          </Typography>
          Add Sub Stage
        </CustomButton>
      </Box>
      {isTPLModalOpen && (
        <CustomTPLModal
          open={isTPLModalOpen}
          onClose={() => setTPLModalOpen(false)}
          subStageId={selectedSubStageId}
        />)}
      {isAddSubStageModalOpen && (
        <CustomSubStageModal
          setToggle={setUpdateToggle}
          isToggle={updateToggle}
          row={selectedRow}
          open={isAddSubStageModalOpen}
          onClose={() => setAddSubStageModalOpen(false)}
          feeStageIdProp={Number(feeStageId)}
          FetchFeeStages={FetchFeeStages}
          AlreadyExists={AlreadyExist}
        />)}
      {isMilestoneModalOpen && (
        <CustomMilestoneModal open={isMilestoneModalOpen} onClose={() => setMilestoneModalOpen(false)}
          subStageId={selectedSubStageId} />
      )}

      <Box sx={{ mt: 4 }}>
        <CustomDataGrid rows={rows} columns={columns} />
      </Box>
    </Box>
  );
};


export default ProposalFeeStageSubStage;